import cn from 'classnames';
// Styles
import styles from './SplitLeftRightView.module.scss';

type SplitLeftRightViewProps = {
  left: React.ReactNode;
  right: React.ReactNode;
  hideLeftOnMobile?: boolean;
  /** `sidebar` keeps the right part a fixed-width column next to a growing left part. */
  variant?: 'even' | 'sidebar';
};

const SplitLeftRightView = ({
  left,
  right,
  hideLeftOnMobile = false,
  variant = 'even',
}: SplitLeftRightViewProps) => {
  return (
    <div
      className={cn(styles.root, { [styles.sidebar]: variant === 'sidebar' })}
    >
      <div
        className={cn(styles.leftPart, {
          [styles.hideLeftOnMobile]: hideLeftOnMobile,
        })}
      >
        {left}
      </div>
      <div className={styles.rightPart}>{right}</div>
    </div>
  );
};

export default SplitLeftRightView;
